import { default as records } from './records/routes'

export default [
    ...records
]
